<template>
  <div data-testid="item" :data-category-id="categoryId" :data-teststate="testState">
    <div v-if="status !== 'exists' && status !== 'hidden'"
         class="custom-checkbox d-flex justify-content-start align-items-center"
         style="cursor: pointer"
         @click="clickValue">
      <i
          v-if="status === 'checked'"
          class="fas fa-check-square checked text-success fa-2x d-inline-block"
          style="display: table-cell;vertical-align: middle"/>
      <i
          v-if="status === '' && disabled === false"
          class="far fa-square text-gray-light fa-2x d-inline-block"
          style="display: table-cell;vertical-align: middle"/>
      <i
          v-if="status !== 'checked' && disabled === true"
          class="fas fa-square text-gray-light fa-2x d-inline-block"
          style="display: table-cell;vertical-align: middle;color: #ccc"/>
      <template v-if="imageEnable && images">
        <div v-for="(img, index) in images" :key="'img' + index" class="ml-2" :class="{'item-is-active': status === 'checked'}" >
          <i class="fas fa-plus" v-if="index > 0"></i>
          <span class="item-pictogram">
            <img :src="'img/' + $root.serviceSetting.User.id + '/' +  img"/>
          </span>
        </div>
      </template>
      <span
          class="form-control-static pl-2 d-inline-block m-0"
          style="display: table-cell;vertical-align: middle;">&nbsp;{{ $t(label) }}</span>

      <span lass="text-right d-inline-block ml-2" v-if="$root.serviceSetting.visible_price_reserve.value === 'true' && price" ><small class="text-muted">￥ {{ price | numberFormat }}</small></span>
    </div>
    <div v-if="status === 'exists' && label" class="custom-checkbox mb-2">
      <!--
      <i
          class="fas fa-check checked d-inline-block"
          style="display: table-cell;vertical-align: middle;color: #CCC"/>
      <span
          class="form-control-static pl-2 d-inline-block"
          style="display: table-cell;vertical-align: middle;color: #DDD">&nbsp;{{ $t(label) }}</span>
          -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyCheckbox',
  props: [
    'label',
    'name',
    'itemId',
    'itemCategory',
    'isEtc',
    'categoryId',
    'status',
    'price',
    'imageEnable',
    'image',
    'disabled'
  ],
  computed: {
    // ブラウザテスト用。アイテムの選択可否を data-teststate として DOM に出す
    testState () {
      if (this.status === 'hidden') return 'hidden'
      if (this.status === 'exists') return 'exists'
      if (this.status === 'checked') return 'checked'
      return this.disabled ? 'disabled' : 'selectable'
    },
    images () {
      // カンマ区切りなので、配列に変換
      if (this.image) {
        return this.image.split(',')
      }
      return this.image
    }
  },
  methods: {
    clickValue (e) {
      // console.log('パラメータ', this.itemCategory, this.checked,  this.isEtc)
      // if (this.itemCategory === 38 || this.itemCategory === 51) {
      //   console.log('重複対象です')
      //   console.log('itemCategory =', this.itemCategory)
      //   console.log('categoryId =', this.categoryId)
      //   console.log('チェック状態 = ', this.checked)
      //   console.log('その他 = ', this.isEtc)
      // } else {
      //   console.log('重複対象ではありません')
      //   console.log('itemCategory =', this.itemCategory)
      //   console.log('categoryId =', this.categoryId)
      //   console.log('チェック状態 = ', this.checked)
      //   console.log('その他 = ', this.isEtc)
      // }
      // this.$emit('update-check', this.name, this.checked)
      if (this.disabled && this.status !== 'checked') {
        return
      }
      this.$emit('update-check', this.categoryId)
    }
  },
  filters: {
    numberFormat (value) {
      let isString = (typeof value === 'string' || value instanceof String)
      if (value === undefined) {
        return null
      }
      if (isString) {
        return value
      }
      if (isNaN(value) && !value.match(/^\d+$/)) {
        return value
      }
      let formatter = new Intl.NumberFormat('ja-JP')
      return formatter.format(value)
    }
  }
}
</script>
<style>
.item-pictogram {
  display: inline-block;
  width: 35px;
  height: 35px;
  text-align: center;
}
.item-pictogram img {
  height: 100%;
  opacity: 0.5;
}
.item-is-active img {
  opacity: 1;
  filter: invert(17%) sepia(91%) saturate(7085%) hue-rotate(128deg) brightness(100%) contrast(106%);
}
</style>
